import {Loader2} from 'lucide-react';
import * as React from 'react';
import {Button} from 'src/Button';

type Props = {
  loading: boolean;
  hasMore: boolean;
  onMore: () => void;
  /** Button text; defaults to "More". */
  label?: string;
};

/**
 * Pagination footer rendered inline at the end of a scrollable list. While a
 * page is in flight it shows a spinner in place, and once the last page has
 * loaded it becomes an end-of-list marker.
 */
export const MoreButton = ({loading, hasMore, onMore, label}: Props) => {
  if (!hasMore) {
    return (
      <div className="text-muted-foreground flex justify-center py-4 text-sm">
        End of list
      </div>
    );
  }

  return (
    <div className="flex justify-center py-3">
      {loading ? (
        <div className="text-muted-foreground flex items-center gap-2 py-2 text-sm">
          <Loader2 className="h-4 w-4 animate-spin" />
          Loading more…
        </div>
      ) : (
        <Button onClick={onMore} variant="outline">
          {label ?? 'More'}
        </Button>
      )}
    </div>
  );
};
